module.exports = __webpack_public_path__ + "static/img/pic-cnt-3.5cab203.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/en/pic-cnt-3.png
// module id = b+9c
// module chunks = 0